import type { DecisioningCreativeComponentVariant } from "./types";

/**
 * Returns the first non-empty creative from a component's variant list.
 *
 * @param variants Variant list for one component.
 * @return First usable creative, or an empty string when none exist.
 */
export const getFirstDecisioningCreativeComponentVariant = (
  variants: DecisioningCreativeComponentVariant[] | undefined
): string => {
  return variants?.find(({ creative }) => creative.length > 0)?.creative ?? "";
};
